// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1cYtY","file":"styles_file__1qcsX"};